import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '../../environments/environment';

/**
 * Ensures all API requests go to the absolute environment.apiUrl.
 * If a request URL is relative and starts with '/api' or 'api',
 * it will be rewritten to `${environment.apiUrl}/...`.
 * Absolute URLs (http/https) are left untouched.
 */
export const apiBaseUrlInterceptor: HttpInterceptorFn = (request, next) => {
  const url = request.url || '';

  // Leave absolute URLs untouched
  if (/^https?:\/\//i.test(url)) {
    return next(request);
  }

  // Only rewrite relative calls that target the API namespace
  const startsWithApi = url.startsWith('/api') || url.startsWith('api');
  if (!startsWithApi) {
    return next(request);
  }

  // Remove leading 'api' or '/api' and join with environment.apiUrl
  const trimmed = url.replace(/^\/?api\/?/, '');
  let newUrl = `${environment.apiUrl}/${trimmed}`;

  // Normalize duplicate slashes except after protocol
  newUrl = newUrl.replace(/([^:]\/)\/+/, '$1');

  const rewritten = request.clone({ url: newUrl });
  return next(rewritten);
};
